import { GridColDef } from '@mui/x-data-grid';

export const columns: GridColDef[] = [
  { 
    field: 'firstName', 
    headerName: 'First Name', 
    flex: 1,
    minWidth: 130
  },
  { 
    field: 'lastName', 
    headerName: 'Last Name', 
    flex: 1,
    minWidth: 130
  },
  { 
    field: 'grade', 
    headerName: 'Grade', 
    width: 100,
    align: 'center',
    headerAlign: 'center',
    valueFormatter: (params) => `Grade ${params.value}`
  },
  { 
    field: 'attendanceRate', 
    headerName: 'Attendance Rate', 
    width: 150,
    align: 'center',
    headerAlign: 'center',
    valueFormatter: (params) => `${params.value}%`
  },
  {
    field: 'gpa',
    headerName: 'GPA',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => params.row.academicPerformance.gpa,
    valueFormatter: (params) => params.value.toFixed(2)
  }
];